import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SharedModule } from '../shared/shared.module';
import { MaterialModule } from '../material/material.module';
import { AddressBooksPageComponent } from './address-books-page/address-books-page.component';
import { AddressBookTableComponent } from './address-book-table/address-book-table.component';
import { ContactsPageComponent } from './contacts-page/contacts-page.component';
import { ContactsTableComponent } from './contacts-table/contacts-table.component';
import { ContactTableFilterComponent } from './contact-table-filter/contact-table-filter.component';
import { ReactiveFormsModule } from '@angular/forms';
import { AddressBookTableFilterComponent } from './address-book-table-filter/address-book-table-filter.component';
import { ContactEditComponent } from './contact-edit/contact-edit.component';
import { CreateContactButtonComponent } from './create-contact-button/create-contact-button.component';
import { AddressesPageComponent } from './addresses-page/addresses-page.component';

@NgModule({
    exports: [
        CreateContactButtonComponent
    ],
    imports: [
        CommonModule,
        MaterialModule,
        RouterModule,
        FontAwesomeModule,
        SharedModule,
        ReactiveFormsModule,
        AddressBooksPageComponent,
        AddressBookTableComponent,
        ContactsPageComponent,
        ContactsTableComponent,
        ContactTableFilterComponent,
        AddressBookTableFilterComponent,
        ContactEditComponent,
        CreateContactButtonComponent,
        AddressesPageComponent
    ]
})
export class AddressBookModule {
}
